import { isArray } from 'util';
import { mapCollection, sortByNumber } from '../../utils/collection.utils';
import { SaleOfferLineProduct } from '../sale-offer-line-product';
import { parseNumber } from '../../utils/number.utils';

export class SaleOfferLineProductBuilder {

  static fromJson(json): SaleOfferLineProduct {
    return (json) ? new SaleOfferLineProduct(
      json.hash,
      json.productHash,
      json.productName,
      json.productCode,
      json.productDescription,
      json.productNeedSerialNumber,
      json.productWeight,
      parseNumber(json.amount),
      parseNumber(json.discountType),
      parseNumber(json.discountNumber),
      parseNumber(json.discountAppliedAmount),
      parseNumber(json.commercialMargin)
    ) : null;
  }

  static fromJsonList(list): SaleOfferLineProduct[] {
    return (isArray(list)) ? sortByNumber('quantity', mapCollection(SaleOfferLineProductBuilder.fromJson, list)) : [];
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/ubaristi-app-test/workspace/src/app/core/models/builders/sale-offer-line-product-builder.ts